import axios from 'axios'
import config from '../common/config'

export async function uploadFile(file, rootPath = 'ylk') { 
    const formdata = new FormData()
    formdata.append('rootPath', rootPath)
    formdata.append('file', file)

    return new Promise(async (resolve, reject) => { 
        const r = await axios.post(`${config.API}file/upload`, formdata, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          resolve(r)
    })
}


// WEBPACK FOOTER //
// ./src/http/upload.js